export const sandboxDailyUrl = 'https://sandbox.pay.qq.com/h5/store_config/fuli_store_config/fuli_store_config.js'
export const sandboxFridayUrl = 'https://sandbox.pay.qq.com/h5/store_config/fuli_friday_top_store/fuli_friday_top_store.js'
export const dailyUrl = 'https://pay.qq.com/h5/store_config/fuli_store_config/fuli_store_config.js'
export const fridayUrl = 'https://pay.qq.com/h5/store_config/fuli_friday_top_store/fuli_friday_top_store.js'
